module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blain-dash"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main-wrapper"
  }, [_c('div', {
    staticClass: "top-wrapper"
  }, [_c('div', {
    staticClass: "data-squares"
  }, [_c('div', {
    staticClass: "data-square-row"
  }, [_c('div', {
    staticClass: "data-square all"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "data"
  }, [_c('animated-number', {
    attrs: {
      "number": _vm.totalOrders
    }
  }), _vm._v(" "), _c('span', [_vm._v("checkouts today")])], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "col1"
  }, [_c('span', [_vm._v("new")]), _vm._v(" "), _c('animated-number', {
    attrs: {
      "number": _vm.newOrders
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col2"
  }, [_c('span', [_vm._v("returning")]), _vm._v(" "), _c('animated-number', {
    attrs: {
      "number": _vm.returningOrders
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col3"
  }, [_c('span', [_vm._v("reseller")]), _vm._v(" "), _c('animated-number', {
    attrs: {
      "number": _vm.resellerOrders
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "data-square flag"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "data"
  }, [_c('animated-number', {
    attrs: {
      "number": _vm.flaggedOrders
    }
  }), _vm._v(" "), _c('span', [_vm._v("total flagged")])], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "col1"
  }, [_c('span', [_vm._v("new")]), _vm._v(" "), _c('animated-number', {
    attrs: {
      "number": _vm.newFlaggedOrders
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col2"
  }, [_c('span', [_vm._v("taken")]), _vm._v(" "), _c('animated-number', {
    attrs: {
      "number": _vm.takenFlaggedOrders
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col3"
  }, [_c('span', [_vm._v("clear avg")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.flagClearAvg))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "data-square-row"
  }, [_c('div', {
    staticClass: "data-square ship"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "data"
  }, [_c('animated-number', {
    attrs: {
      "number": _vm.shipOrders
    }
  }), _vm._v(" "), _c('span', [_vm._v("awaiting fulfillment")])], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "col1"
  }, [_c('span', [_vm._v("in house")]), _vm._v(" "), _c('animated-number', {
    attrs: {
      "number": _vm.inHouseOrders
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col2"
  }, [_c('span', [_vm._v("third party")]), _vm._v(" "), _c('animated-number', {
    attrs: {
      "number": _vm.thirdPartyOrders
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col3"
  }, [_c('span', [_vm._v("in transit")]), _vm._v(" "), _c('animated-number', {
    attrs: {
      "number": _vm.shipInTransit
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "data-square pickup"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "data"
  }, [_c('animated-number', {
    attrs: {
      "number": _vm.pickupOrders
    }
  }), _vm._v(" "), _c('span', [_vm._v("to be picked")])], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "col1"
  }, [_c('span', [_vm._v("in store")]), _vm._v(" "), _c('animated-number', {
    attrs: {
      "number": _vm.storePickupOrders
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col2"
  }, [_c('span', [_vm._v("drive thru")]), _vm._v(" "), _c('animated-number', {
    attrs: {
      "number": _vm.driveThruOrders
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col3"
  }, [_c('span', [_vm._v("ready")]), _vm._v(" "), _c('animated-number', {
    attrs: {
      "number": _vm.pickupReady
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "chart-wrapper"
  }, [_c('div', {
    staticClass: "chart-stats"
  }, [_c('div', {
    staticClass: "data-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Projected")]), _vm._v(" "), _c('animated-number', {
    attrs: {
      "number": _vm.projectedOrders,
      "threshold": _vm.goalOrders
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "data-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Today's Goal")]), _vm._v(" "), _c('animated-number', {
    attrs: {
      "number": _vm.goalOrders,
      "goal-reached": _vm.goalReached
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "data-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Yesterday")]), _vm._v(" "), _c('animated-number', {
    attrs: {
      "number": _vm.yesterdayOrders
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "data-item"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Last Year")]), _vm._v(" "), _c('animated-number', {
    attrs: {
      "number": _vm.lastYearOrders
    }
  })], 1)]), _vm._v(" "), _vm._m(5)])]), _vm._v(" "), _c('div', {
    staticClass: "middle-wrapper"
  }, [_c('div', {
    staticClass: "data-item long"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Users")]), _vm._v(" "), (_vm.activeUserCounts != null) ? _c('span', {
    staticClass: "user-count"
  }, [_vm._m(6), _vm._v(" "), _c('animated-number', {
    attrs: {
      "number": _vm.activeUserCounts.web
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.activeUserCounts != null) ? _c('span', {
    staticClass: "user-count"
  }, [_vm._m(7), _vm._v(" "), _c('animated-number', {
    attrs: {
      "number": _vm.activeUserCounts.ios
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.activeUserCounts != null) ? _c('span', {
    staticClass: "user-count"
  }, [_vm._m(8), _vm._v(" "), _c('animated-number', {
    attrs: {
      "number": _vm.activeUserCounts.android
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "data-item short"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Active Carts")]), _vm._v(" "), _c('animated-number', {
    attrs: {
      "number": _vm.activeCarts
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "data-item short"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("In Checkout")]), _vm._v(" "), _c('animated-number', {
    attrs: {
      "number": _vm.activeCheckouts
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "data-item mid"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Checkout Velocity")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.checkoutVelocity))]), _vm._v(" "), _c('span', [_vm._v("/min")])]), _vm._v(" "), _c('div', {
    staticClass: "data-item long"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Last Order")]), _vm._v(" "), _c('span', {
    staticClass: "lastorder"
  }, [_c('span', {
    staticClass: "destination"
  }, [_vm._v(_vm._s(_vm.lastOrderDestination))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lastOrderTime))])])])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-wrapper"
  }, [_c('div', {
    staticClass: "system-summary"
  }, [_c('h2', [_vm._v("Systems")]), _vm._v(" "), _c('div', {
    staticClass: "summary-wrapper"
  }, [_c('div', {
    staticClass: "summary-row"
  }, [_c('span', [_vm._v("Active Web/API Servers")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.activeWebServers))])]), _vm._v(" "), _c('div', {
    staticClass: "summary-row"
  }, [_c('span', [_vm._v("Avg CPU Utilization")]), _vm._v(" "), _c('strong', {
    class: _vm.cpuClass
  }, [_vm._v(_vm._s(_vm.avgCpu) + "%")])]), _vm._v(" "), _c('div', {
    staticClass: "summary-row"
  }, [_c('span', [_vm._v("Main Database")]), _vm._v(" "), _c('status-value', {
    attrs: {
      "status": _vm.mainDbStatus
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "summary-row"
  }, [_c('span', [_vm._v("Catalog Database")]), _vm._v(" "), _c('status-value', {
    attrs: {
      "status": _vm.catDbStatus
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "summary-row"
  }, [_c('span', [_vm._v("Redis Cache")]), _vm._v(" "), _c('status-value', {
    attrs: {
      "status": _vm.redisStatus
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "global-avail"
  }, [_c('h2', [_vm._v("Global Availability")]), _vm._v(" "), _c('ul', {
    staticClass: "avail-wrapper"
  }, _vm._l((_vm.globalAvail), function(g) {
    return _c('li', {
      key: g.ipAddress
    }, [_c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (g.status === 'UP'),
        expression: "g.status === 'UP'"
      }],
      staticClass: "fas fa-fw fa-lg fa-check ok"
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (g.status === 'DOWN'),
        expression: "g.status === 'DOWN'"
      }],
      staticClass: "fas fa-fw fa-lg fa-exclamation-triangle critical"
    }), _vm._v("\n\t\t\t\t\t\t" + _vm._s(g.regionName) + "\n\t\t\t\t\t")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "api-issues"
  }, [_c('h2', [_vm._v("External Service Issues")]), _vm._v(" "), _c('h3', [_vm._v("within the last hour")]), _vm._v(" "), _c('ul', {
    staticClass: "api-wrapper"
  }, _vm._l((_vm.apiIssues), function(a) {
    return _c('li', {
      key: a.apiKey,
      staticClass: "api-row"
    }, [_c('span', [_vm._v(_vm._s(a.apiName))]), _vm._v(" "), _c('status-value', {
      attrs: {
        "status": a.issueCount,
        "since": a.timeSinceMostRecent
      }
    })], 1)
  }))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('h1', [_c('span', {
    staticClass: "logo"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("E-commerce Mission Control")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('i', {
    staticClass: "fas fa-shopping-cart fa-lg fa-fw"
  }), _vm._v(" All Orders")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('i', {
    staticClass: "fas fa-flag fa-lg fa-fw"
  }), _vm._v(" Flagged")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('i', {
    staticClass: "fas fa-truck fa-lg fa-fw"
  }), _vm._v(" Ship Orders")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('i', {
    staticClass: "fas fa-car fa-lg fa-fw"
  }), _vm._v(" Pickup Orders")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chart-inner-wrapper"
  }, [_c('canvas', {
    attrs: {
      "id": "checkoutChart",
      "width": "400",
      "height": "200"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "user-icon"
  }, [_c('i', {
    staticClass: "fas fa-globe"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "user-icon"
  }, [_c('i', {
    staticClass: "fab fa-apple"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "user-icon"
  }, [_c('i', {
    staticClass: "fab fa-android"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-68c5a5b4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/blain-dash.vue
// module id = 574
// module chunks = 0